import React, { Component, PropTypes } from 'react';

export default class JSErrorComponent extends React.Component {
  render() {
    throw new Error("test - jserror")
    return <h1>Hello</h1>;
  }
}